module.exports = "\nheader { background-color:beige; padding:20px; } \nnav a[routerLink] { display:inline-block; margin-right:20px;  } \na { font-size:1rem; } \n*:focus {\n    -webkit-box-shadow: 0 0 0 1px white, 0 0 0 3px black, 0 0 0 4px white;\n            box-shadow: 0 0 0 1px white, 0 0 0 3px black, 0 0 0 4px white;\n    z-index: 1;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main